'use strict';

var cov_2hqcdwjh8y = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/header/header.js',
      hash = '43239afb5c8607a6d234a3401ced3edab37f0dab',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/header/header.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 8,
          column: 5
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      '0': 0
    },
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_2hqcdwjh8y.s[0];
angular.module('app').component('martyHeader', {
  bindings: {
    user: '='
  },
  templateUrl: 'app/header/header.html'
});